// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"M2GniLqray2dbDZcQgTFX","stepper":"e8UPZ0zAWrCz5yZjURzBd","stepperCard":"hC8UG-eWZI3knWa0hjM0-","footer":"_3hfbi2UkUjKUNLbZcoaRdG"};


//////////////////
// WEBPACK FOOTER
// ./src/views/CreateBillingOrder/styles.css
// module id = 1087
// module chunks = 0